<div class="performance-lab-new-result">
    <div *ngIf="!isAuthorized || perResults === null ">
        <h4>{{authorizationMsg}}</h4>
    </div>

    <div *ngIf="isAuthorized">
        <div style="text-align: center; color: rgb(207, 98, 80);" *ngIf="showLoadingDiv">
            Your results are being compiled. Please wait a few minutes for the detailed results.
            <div class="loader m-auto"></div>
        </div>
        <div>
            <div class="row mb-2" *ngIf="!testCompleted">
                <div class="col-8">
                    <label class="form-check-inline">
                        <input type="checkbox" [(ngModel)]="isAutoRefresh" (change)="setAutoRefresh();" class="mr-2">
                        Auto Refresh
                    </label>

                    <select [(ngModel)]="autoRefreshInterval" (change)="setAutoRefresh();" class="mr-2">
                        <option value="5">5 Sec</option>
                        <option value="10">10 Sec</option>
                        <option value="15">15 Sec</option>
                        <option value="30">30 Sec</option>
                        <option value="60">1 Min</option>
                    </select>

                    <i class="fas fa-sync clickable mr-2" style="font-size: 15px;" ngbTooltip="Refresh"
                        (click)="getTestcaseTopDetails()"></i>
                </div>
                <div class="col-4 text-right" *ngIf="perResults.testcaseExecSumm?.performanceRequest.parallelFlow">
                    <em> {{autoRefreshMsg()}}</em>
                    <img src="/assets/images/spin.svg" alt="spin" width="18" *ngIf="isAutoRefresh">
                </div>
                <div class="col-4 text-right" *ngIf="!perResults.testcaseExecSumm?.performanceRequest.parallelFlow">
                    <em> {{!isAutoRefresh ? 'Auto refresh is paused ' : 'Please wait test is running ..'}}</em>
                    <img src="/assets/images/spin.svg" alt="spin" width="18" *ngIf="isAutoRefresh">
                </div>
            </div>
            <div class="row title">
                <div class="font-bold d-flex ml-3" style="font-size:15px;">
                    Testcase: <a [routerLink]="['/testcase/',perResults.testcaseExecSumm?.id]" target="_blank">{{perResults.testcaseExecSumm?.name}}</a>
                </div>
                <div class="ml-auto font-bold a-icon d-flex" style="font-size:15px;">
                    <div class="mr-2 d-flex" *ngIf="testCompleted && testcaseTopLevelDetails?.response?.loadtestConfig?.storeResult">
                        <div class="m-1">Quick View</div>
                        <ui-switch defaultBgColor="#cf6250" checkedTextColor="#fff" uncheckedTextColor="#fff" class="ml-2 mr-2"
                        (change)="showNewGraph($event)" (ngModelChange)="showNewGraphData" size="small"></ui-switch>
                        <div class="m-1">Detailed View</div>
                    </div>
                    |
                    <div>
                      <a class="fas fa-redo clickable m-1 a-icon" *ngIf="testCompleted && !perResults.testcaseExecSumm?.performanceRequest.usingJmxFile" [routerLink]="['/performance/loadTesting/rerun', perResults.testcaseExecSumm?.performanceRequest.id]" ngbTooltip="Re-run"></a>
                      <a class="fas fa-redo clickable m-1 a-icon" *ngIf="testCompleted && perResults.testcaseExecSumm?.performanceRequest.usingJmxFile" [routerLink]="['/performance/loadTesting/jmx-upload', perResults.testcaseExecSumm?.performanceRequest.id]" ngbTooltip="Re-run"></a>
                      <span class="fa fa-file-download clickable m-1 a-icon text-primary" *ngIf="perResults.testcaseExecSumm.resultFileAvailable  && perResults.testcaseExecSumm?.id !== null" (click)="formalRunFileDownload(perResults.testcaseExecSumm?.id, perResults.testcaseExecSumm?.performanceRequest.id)" ngbTooltip="Click to download" placement="left"></span>
                      <a class="fas fa-ban clickable m-1 text-danger a-icon" (click)="abortRunningTest()" *ngIf="!testCompleted" ngbTooltip="Abort test" placement="left"></a>
                    </div>
                </div>
                <div class="col-12 text-right">
                </div>
            </div>
        </div>
        <div>
            <ul ngbNav #nav="ngbNav" class="testdata-nav nav-tabs" style="border-bottom: 1px solid #a8a8a8;" [destroyOnHide]="false"
                [activeId]="activeTabId" (navChange)="changeTab($event)">
                <!-- Session Summary -->
                <li title="Session Summary" [ngbNavItem]="0">
                    <a ngbNavLink>Test Result</a>
                    <ng-template ngbNavContent>
                        <app-new-performance-result-summary (showLoadingDivEmitter)="showLoadingDivEmitter($event)"
                            [perResults]="perResults" [showNewGraphSection]="showNewGraphData" [isAutoRefresh]="isAutoRefresh" [autoRefreshInterval]="autoRefreshInterval" [testcaseTopLevelDataInput]="testcaseTopLevelDetails"></app-new-performance-result-summary>
                    </ng-template>
                </li>
                <!-- Load Test Details -->
                <li title="Load Test Details" [ngbNavItem]="1">
                    <a ngbNavLink>Load Test Details</a>
                    <ng-template ngbNavContent>
                        <app-new-performance-node-summary [perResults]="perResults"></app-new-performance-node-summary>
                    </ng-template>
                </li>
                <!-- System Stats -->
                <li title="System Stats" [ngbNavItem]="2" [appPermission]="[ADMIN,SUPER_ADMIN]">
                    <a ngbNavLink>System Stats</a>
                    <ng-template ngbNavContent>
                        <app-new-system-stats [machineList]=machineStats></app-new-system-stats>
                    </ng-template>
                </li>
            </ul>
            <div [ngbNavOutlet]="nav" class="mt-2"></div>
        </div>
    </div>
</div>